<template>
  <div class="flex pt-2">
    <span class="icon">
      <vs-icon
        v-if="params.data.tags.map(e => e.name.en).includes('premium')"
        icon-pack="speakol"
        icon="speakol-premium-solid"
        class="star-solid-icon premium-icon"
      ></vs-icon>
    </span>

    <span class="system-campaign-name" :class="[params.data.tags.map(e => e.name.en).includes('premium') ? 'pl-3' : 'pl-8']">
      {{ params.data.name }}
    </span>
  </div>
</template>
<script>
export default {}
</script>


<style lang="scss" scoped>

  .campaignTitle {
    white-space: initial;
    display: inline-block;
    word-wrap: break-word;
    line-height: 19px;
    max-width: 350px;
    padding: 15px 15px 15px 0;
  }

  .premium-icon {
    color: #ffbb07;
    font-size: 22px !important;
  }

  span.icon {
    margin-top: 5px;
  }

</style>
